import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-20 md:pt-28 pb-8 md:pb-12 px-4 bg-white" data-id="element-74">
      <div className="max-w-3xl mx-auto text-center" data-id="element-75">
        <h1 className="text-3xl md:text-5xl font-black text-gray-900 mb-4 md:mb-6 leading-tight" data-id="element-76">
          Menos pantallas, más abrazos: descubrí el poder del Pack 100 Citas
        </h1>

        <button onClick={scrollToPricing} className="w-3/4 max-w-xs md:w-full md:max-w-lg mx-auto block cursor-pointer md:hover:scale-105 md:transition-transform md:duration-300" data-id="element-77">
          <img src="https://cdn.magicpatterns.com/uploads/nJ6227LTvBcXZFid5u8iHs/MOCAP_100_CITAS.png" alt="Pack 100 Citas" className="w-full h-auto md:drop-shadow-2xl mb-6 md:mb-8 rounded-xl" fetchPriority="high" decoding="auto" loading="eager" sizes="(max-width: 768px) 75vw, 512px" width={600} height={400} style={{
          aspectRatio: '3/2',
          objectFit: 'contain'
        }} data-id="element-78" />
        </button>

        <div className="bg-yellow-100 border-l-4 border-yellow-500 p-3 md:p-4 mb-6 md:mb-8 text-left md:text-center" data-id="element-79">
          <p className="text-base md:text-xl font-medium text-gray-800" data-id="element-80">
            Descubre el Pack 100 Citas 👨‍👩‍👧‍👦 y vive experiencias únicas con tus
            hijos y toda la familia. Cada cita 💫 es un momento especial que
            fortalece los lazos, despierta sonrisas y crea recuerdos para
            siempre ❤️.
          </p>
        </div>

        <div className="max-w-md mx-auto" data-id="element-81">
          <CTAButton text="👉 SÍ, QUIERO LA OFERTA AHORA" subtext="Descarga Digital Inmediata • Garantía de satisfacción de 7 días" size="sm" data-id="element-82" />
        </div>
      </div>
    </section>;
}